import { usePlatform } from '../contexts/PlatformContext.js';
import type { FrameContext } from '@annoteer/platform-adapter';

/**
 * Convenience hook for Teams-specific context values.
 */
export function useTeamsContext() {
  const { context, user, isInitialized, error } = usePlatform();

  return {
    frameContext: (context?.frameContext ?? 'unknown') as FrameContext,
    meetingId: context?.meetingId ?? null,
    theme: context?.theme ?? 'default',
    user,
    isInitialized,
    isDevMode: error !== null,
  };
}

/**
 * True when running inside the Teams mobile app (iOS / Android).
 *
 * Gate every purchase, pricing, and billing-management surface on this.
 * Microsoft's marketplace certification policy 114048 forbids upsell,
 * purchase, and payment-related references in Teams mobile apps, and
 * validation files a Must-Fix when it finds one — issue #13 on ticket
 * 5711551 was Stripe Checkout opening from the meeting side panel.
 *
 * Defaults to false when the client is unknown, so a real desktop customer
 * can always reach checkout. See mapClientType in TeamsPlatformAdapter for
 * why the fallback leans that way.
 */
export function useIsMobileClient(): boolean {
  const { context } = usePlatform();
  return context?.clientType === 'mobile';
}
